import React, { Component } from 'react';
require('./footer.css');

class Footer extends Component {

    render() {
        return (
            <div className="footerCard">
                <h2>Tinqer</h2>
            </div>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer/Footer.js